import axios from 'axios';

// import { verifyToken } from './tokenUtil';

export function post(
    endpoint,
    body,
    options = { token: '', traceId: '', headers: {} },
) {
    const { token, headers, traceId } = options;

    async function execRequest(resolve, reject) {
        const reqHeaders = {
            authorization: 'Bearer ' + token,
            'x-trace-id': traceId,
            ...headers,
        };

        axios
            .post(endpoint, body, {
                headers: reqHeaders,
            })
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                resolve(error);
            });
    }

    return new Promise(execRequest);
}

export default post;
